import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";

import Home from "./components/pages/Home";
import Header from "./components/general/Header"
import Footer from "./components/general/Footer";
import Services from "./components/pages/Services";
import Bridal from "./components/pages/Bridal";
import ContactPage from "./components/pages/Contact";


function App() {
  return (
    <Router>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/bridal" element={<Bridal />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <a
        href="tel:+916394941232"
        style={{
          position: "fixed",
          bottom: "25px",
          right: "25px",
          zIndex: "999999",
          background:
            "linear-gradient(to right,#16a34a,#22c55e)",
          color: "#fff",
          padding: "14px 22px",
          borderRadius: "60px",
          textDecoration: "none",
          fontWeight: "700",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          boxShadow:
            "0 15px 35px rgba(34,197,94,0.35)",
          transition: "all .3s ease",
          cursor: "pointer",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform =
            "translateY(-4px)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform =
            "translateY(0px)";
        }}
      >
        <FaPhoneAlt />
      </a>
      <a
        href="https://wa.me/916394941232"
        target="_blank"
        rel="noreferrer"
        style={{
          position: "fixed",
          bottom: "90px",
          right: "25px",
          zIndex: "999999",
          background:
            "linear-gradient(to right,#1ea952,#25D366)",
          color: "#fff",
          width: "55px",
          height: "55px",
          borderRadius: "50%",
          textDecoration: "none",
          fontWeight: "700",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow:
            "0 15px 35px rgba(37,211,102,0.35)",
          transition: "all .3s ease",
          cursor: "pointer",
          fontSize: "26px",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform =
            "translateY(-4px)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform =
            "translateY(0px)";
        }}
      >
        <FaWhatsapp />
      </a>
      <Footer />
    </Router>
  );
}

export default App;